export class CenterType {

    private internalId: string;
    private centerTypeCode: string;
    private centerTypeName: string;
    private centerTypeDescription: string;

    constructor(internalId?: string, centerTypeCode?: string, centerTypeName?: string, centerTypeDescription?: string) {
        this.internalId = internalId;
        this.centerTypeCode = centerTypeCode;
        this.centerTypeName = centerTypeName;
        this.centerTypeDescription = centerTypeDescription;
    }

    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set CenterTypeCode(centerTypeCode) {
        this.centerTypeCode = centerTypeCode;
    }
    public set CenterTypeName(centerTypeName) {
        this.centerTypeName = centerTypeName;
    }
    public set CenterTypeDescription(centerTypeDescription) {
        this.centerTypeDescription = centerTypeDescription;
    }

    public get InternalId() {
        return this.internalId;
    }
    public get CenterTypeCode() {
        return this.centerTypeCode;
    }
    public get CenterTypeName() {
        return this.centerTypeName;
    }
    public get CenterTypeDescription() {
        return this.centerTypeDescription;
    }

}